import {CREATE_NEWS_START} from "../../types";

export const create_news = (payload) => ({
  type: CREATE_NEWS_START,
  payload,
});
